/**
 * @flow
 */

import React from "react"
import styled from "styled-components"

import Button from "./Button"

type Props = {
  open: boolean,
  onConfirm: () => void,
  onCancel: () => void,
  confirmLabel?: string,
  cancelLabel?: string,
  children?: React$Node,
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 1000;
`

const Card = styled.div`
  background-color: var(--white);
  border-radius: 8px;
  padding: var(--gutter-m, 1.5rem);
  max-width: 420px;
  width: 100%;
  box-shadow: 2px 2px 20px -8px rgba(0, 0, 0, 0.5);

  .modal-body {
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .modal-actions {
    display: flex;
    gap: 1rem;
    button {
      flex: 1;
    }
  }
`

const CancelButton = styled(Button)`
  min-width: auto;
  flex: 1;
  background: var(--white);
  color: var(--havelock-blue);
  border: 1px solid var(--havelock-blue);
`

const CustomButton = styled(Button)`
  min-width: auto;
  flex: 1;
`

const Modal = ({
  open,
  onConfirm,
  onCancel,
  confirmLabel = "Yes",
  cancelLabel = "No",
  children,
}: Props) => {
  if (!open) return null

  const handleOverlayClick = () => {
    onCancel()
  }

  const stopPropagation = event => {
    event.stopPropagation()
  }

  return (
    <Overlay onClick={handleOverlayClick}>
      <Card onClick={stopPropagation}>
        <div className="modal-body">{children}</div>
        <div className="modal-actions">
          <CancelButton type="button" onClick={onCancel}>
            {cancelLabel}
          </CancelButton>
          <CustomButton type="button" onClick={onConfirm}>
            {confirmLabel}
          </CustomButton>
        </div>
      </Card>
    </Overlay>
  )
}

export default Modal
